import { FormControl, Grid, InputLabel, Select, Table, TableBody, TableCell, TableRow
    , TextField, Typography, IconButton, Box } from '@mui/material'
import { AddCircle as IconAddCircle, Delete as IconDelete } from "@mui/icons-material";
import api from "../services/api";
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addPersonaAntecedentes, removePersonaAntecedentes, setDatoPersonaAntecedentes
    , setPersonaAntecedentes, setTiposAntecedentes, initPersonPast, defaultPersonaAntecedentes } from '../redux/personPastSlice'
import DialogYesNo from './DialogYesNo'
import * as personaService from "../services/personaService";
import * as catalogoService from "../services/catalogoService";

const PersonPast = (props) => {
    const dispatch = useDispatch();
    const sliceKey = props.sliceKey;

    useEffect(() => {
        dispatch(initPersonPast({ sliceKey }));
    }, [dispatch, sliceKey]);

    const personaAntecedentes = useSelector((state) => state.personPast[sliceKey]?.personaAntecedentes);
    const tiposAntecedentes = useSelector((state) => state.personPast[sliceKey]?.tiposAntecedentes);
    
    const [openDialogDelete, setOpenDialogDelete] = useState(false)
    const openCloseDialogDelete = () => { setOpenDialogDelete(!openDialogDelete); }
    const [selectNumero, setSelectNumero] = useState(null);
    const [selectId, setSelectId] = useState(null);
    
    const fetchPersonaAntecedentes = useCallback(async () => {
        const response = await personaService.getsPersonaAntecedenteView(props.id)
        dispatch(setPersonaAntecedentes({sliceKey: sliceKey, data: response?.length ? response : defaultPersonaAntecedentes}));
    }, [])
    const fetchTiposAntecedentes = useCallback(async () => {
        const response = await catalogoService.getCatalogosByPadre(102)
        dispatch(setTiposAntecedentes({sliceKey: sliceKey, data: response}));
    }, [])

    useEffect(() => {
        fetchPersonaAntecedentes();
        fetchTiposAntecedentes();
    }, [])

    const deletePersonaAntecedente = async () => {
        await personaService.deletePersonaAntecedente(props.id, selectNumero)
        dispatch(removePersonaAntecedentes({sliceKey: sliceKey, numero: selectNumero}));
    }
    const setItemValue = (numero, name, value) => {
        dispatch(setDatoPersonaAntecedentes({sliceKey: sliceKey, numero: numero, name: name, value: value}))
    }

    return (
        <Grid container>
            <Grid item>
                <Typography variant="h7">
                    <Box sx={{ fontWeight: 'bold' }} padding={0}>
                        {"Antecedentes (" + (personaAntecedentes?.length || 0) + ")"}
                    </Box>
                </Typography>
            </Grid>
            <Grid item>
                <IconButton size="small" aria-label="agregar" style={{height: 10}} onClick={() => {
                    dispatch(addPersonaAntecedentes(sliceKey));
                }}>
                    <IconAddCircle />
                </IconButton>
            </Grid>
            <Grid container>
                {/* {JSON.stringify(personaAntecedentes)} */}
                <Table size="small">
                    <TableBody>
                        {personaAntecedentes?.map((row, index) => (
                            <TableRow key={row.numero} sx={(theme) => ({
                                backgroundColor: index % 2 === 1 ? theme.palette.action.selected : 'inherit',
                                "&:last-child td, &:last-child th": { borderRadius: "0.5em" },
                            })}>
                                <TableCell>
                                    <Grid container spacing={1} padding={0}>
                                        <Grid item xs={8} sm={12}>
                                            <Box display="flex" alignItems="center" gap={0}>
                                                <FormControl required fullWidth>
                                                    <InputLabel htmlFor="input-tipoantecedente">Tipo</InputLabel>
                                                    <Select
                                                        native
                                                        label="Tipo"
                                                        value={row.idTipoAntecedente || 0}
                                                        fullWidth
                                                        onChange={(event, newValue) => {
                                                            setItemValue(row.numero, "idTipoAntecedente", event.target.value);
                                                        }}
                                                        inputProps={{
                                                            name: 'idTipoAntecedente',
                                                            id: 'input-tipoantecedente',
                                                        }}
                                                        size="small"
                                                    >
                                                        <option key={0} value={0}>{"(Seleccione)"}</option>
                                                        {tiposAntecedentes?.map((row) => (
                                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                                <IconButton aria-label="delete" onClick={() => {
                                                    if (row.idPersona > 0) {
                                                        setSelectId(row.id);
                                                        setSelectNumero(row.numero);
                                                        setOpenDialogDelete(true);
                                                    }
                                                    else {
                                                        dispatch(removePersonaAntecedentes({sliceKey: sliceKey, numero: row.numero}));
                                                    }
                                                }}>
                                                    <IconDelete />
                                                </IconButton>
                                            </Box>
                                        </Grid>
                                        {/* <Grid item xs={10} sm={7}>
                                            <Box display="flex" alignItems="center" gap={0}>
                                                <TextField
                                                    required
                                                    name="valor"
                                                    label="Valor"
                                                    fullWidth
                                                    value={row.valor || ""}
                                                    onChange={(event) => {
                                                        setItemValue(row.numero, "valor", event.target.value);
                                                    }}
                                                    size="small"
                                                />
                                                <IconButton aria-label="delete" onClick={() => {
                                                    if (row.idPersona > 0) {
                                                        setSelectId(row.id);
                                                        setSelectNumero(row.numero);
                                                        setOpenDialogDelete(true);
                                                    }
                                                    else {
                                                        dispatch(removePersonaAntecedentes({sliceKey: sliceKey, numero: row.numero}));
                                                    }
                                                }}>
                                                    <IconDelete />
                                                </IconButton>
                                            </Box>
                                        </Grid> */}
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Grid>
            <DialogYesNo open={openDialogDelete} openClose={openCloseDialogDelete} setYes={deletePersonaAntecedente} setNo={() => { return }}
                titulo={"Borrar contacto"}
                texto={"Esta seguro de borrar el antecedente?"} ></DialogYesNo>
        </Grid>
    )
}

export default PersonPast;
